{
	"imprintTitle": "Aviso legal",
	"termsAndConditionsTitle": "Términos y condiciones",
	"privacyPolicyTitle": "Política de privacidad",
	"openSourceAttributionTitle": "Atribución de código abierto"
}
